import { render, staticRenderFns } from "./CrossLine.vue?vue&type=template&id=82d89552&scoped=true"
import script from "./CrossLine.vue?vue&type=script&lang=js"
export * from "./CrossLine.vue?vue&type=script&lang=js"
import style0 from "./CrossLine.vue?vue&type=style&index=0&id=82d89552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d89552",
  null
  
)

export default component.exports